import React from "react";
import Error from "../components/errors/Error";


function ErrorPage() {
  return <Error />;
}

export default ErrorPage;
